import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminMyDepartments() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin My Departments page</h1>
                </div>
            </div>
        </>
    )
}
